export default __webpack_public_path__ + "static/media/shopify-logo-icon.4005b5ca.svg";